define('modules/profiles/notifications/views/monitoring.roles.notifications.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/views/base.view',
    'text!modules/profiles/notifications/templates/monitoring.roles.notifications.template.html'
], function(Prospector,$, _,Backbone,
            Marionette,
            BaseView,
            Template) {
    var MonitoringRolesNotificationView = BaseView.extend({
        template: _.template(Template),
        className: 'snackbar snackbar-opened',
        loaderHtml:'',
        initialize: function(options){
            this.parent = options.parent;
            this.model = options.model;
            BaseView.prototype.initialize.call(this, options);
        },
        mEvents:function() {
            var base = {
            };
            var click = {
                'click .closeBtn': 'close',
                'click .openLink': 'procOpenLink'
            };
            $.extend(base,click);
            return base;
        },
        onRender:function(){
            this.$('.companyName').html(this.model.get('name'));
            },
        procOpenLink:function(){
            this.close();
            Prospector.trigger("showRoleMonitoringGroupsControl", {parent: this, preSelectedBinType: "alertFlag"});
        },
        close:function(){
            this.unbind();
            $(this.el).remove();
        }
    });
    return MonitoringRolesNotificationView;
});
